import CustomList from "../Util/List/CustomList/CustomList";
import CustomListContainer from "../Util/List/CustomList/CustomListContainer";
import config from "../../../../application/config/config";

function List() {
  const pathFrontEnd = '/core/applicationsfunctionalities/';
  const paths = {
      pathAdd: pathFrontEnd + 'add',
      pathEdit: pathFrontEnd + 'edit',
      pathView: pathFrontEnd + 'view',
      endpointDelete: `${config.endpoints.backend}core/applicationsfunctionalities/delete`,
      endpoint: config.endpoints.backend + 'core/applicationsfunctionalities/getall'
  }
  let list = {
    labelTitle: "Lista de Funcionalidades",
    fieldsShowOnDelete: ["functionality"],
    showPrintButtons: true,
    columns: [
      {
        name: "functionality",
        label: "Funcionalidade",
        sortable: true
      },
    ],
  };

  list = {...list, ...paths}

  return (
    <div>
      <CustomListContainer
        pathAdd={list.pathAdd}
        labelTitle={list.labelTitle}
        content={<CustomList list={list} />}
      />
    </div>
  );
}
export default List;